/**
 * ADMIN ENTRY POINT — Único punto de entrada para Vite.
 * Importa CSS (en orden) y JS (el grafo de dependencias se resuelve solo).
 */

// Storage namespace SSOT — primero. Migración loto37_admin_token → <brand>_admin_token.
import '@shared/config/storage-namespace.js';

// Versión del build (inyectada por Vite en build-time, ver vite.config.js
// define.__BUILD_ID__). Primera línea de la consola SIEMPRE: si algo falla, lo
// primero que ves es qué versión corrés → descarta de un vistazo el caché viejo
// / Service Worker desactualizado. `typeof` guard por si el define faltara.
// eslint-disable-next-line no-undef
console.log('%c[Admin] build ' + (typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev'), 'color:#3b82f6;font-weight:600');

// Ciclo de vida del Service Worker (SSOT: shared/service-worker/SPEC.md).
// Política admin = próximo-arranque: JAMÁS recargar en caliente por un deploy
// (formularios largos abiertos); el build nuevo se toma en el siguiente load.
// La autorecuperación en caliente queda para el caso realmente roto: módulo
// lazy que pide un chunk con hash viejo post-deploy ⇒ RELOAD_REQUIRED ⇒
// reload con guard anti-loop (tope 3 + gate online).
import { registrarServiceWorker } from '@shared/service-worker/core/registro-cliente.js';

registrarServiceWorker({
    politicaUpdate: 'proximo-arranque',
    storageKeyGuard: 'admin_reload_required_count',
});

// CSS modules — mismo orden que build-admin-css.sh
import './css/admin/modules/00-variables.css';
import './css/admin/modules/01-base.css';
import './css/admin/modules/02-layout.css';
import './css/admin/modules/03-buttons.css';
import './css/admin/modules/04-forms.css';
import './css/admin/modules/05-modals.css';
import './css/admin/modules/06-tables.css';
import './css/admin/modules/07-cards.css';
import './css/admin/modules/09-toast.css';
import './css/admin/modules/10-command-center.css';
import './css/admin/modules/11-filters.css';
import './css/admin/modules/12-nodos-tree.css';
import './css/admin/modules/lotowheel-config.css';
import './css/admin/modules/08-view-login.css';
import './css/admin/modules/99-responsive.css';
import './css/admin/modules/13-node-stats-dashboard.css';
import './css/admin/modules/14-platform-utilities.css';
import './css/admin/modules/15-confirmacion-destructiva.css';
import './css/admin/modules/16-ficha-entidades.css';
import './css/admin/modules/17-ficha-dispositivos.css';
import './css/admin/modules/18-pasarelas-actividad.css';
import './css/admin/modules/19-dashboard-red.css';
import './css/admin/modules/20-marketing-analisis-promos.css';
import './css/admin/modules/21-cascada-preview.css';
import './css/admin/modules/22-listado-canonico.css';
import './css/admin/modules/23-marketing-presentation-preview.css';
import './css/admin/modules/24-pozo-acumulado.css';
import './css/admin/modules/25-digi12-editor.css';
import './js/lib/nouislider.css';

// Web Components — Custom Elements (Light DOM)
import './js/components/views/admin-command-center-dashboard-sorteos-alertas-view.js';
import './js/components/views/admin-juegos-lotowheel-virtuales-view.js';
import './js/components/views/admin-auditoria-view.js';
import './js/components/views/admin-clientes-jugadores-bloqueo-view.js';
import './js/components/views/admin-marketing-promociones-plantillas-view.js';
import './js/components/views/admin-actividad-tickets-wallets-pasarelas-view.js';
import './js/components/views/admin-finanzas-movimientos-cortes-contratos-view.js';
import './js/components/views/admin-plataforma-red-dispositivos-entidades-view.js';

// JS — admin.js importa todos los módulos principales (grafo ESM)
import './js/admin.js';

// LotoWheel extensions — Object.assign que agregan métodos a LotowheelModule
// lotowheel.js se evalúa primero (dependencia), luego estos extienden el objeto
import './js/modules/games/lotowheel/lotowheel-modal-apariencia.js';
import './js/modules/games/lotowheel/lotowheel-modal-fichas.js';
import './js/modules/games/lotowheel/lotowheel-modal-bloqueos.js';
import './js/modules/games/lotowheel/lotowheel-modal-algoritmo.js';
import './js/modules/games/lotowheel/lotowheel-modal-acceso.js';
import './js/modules/games/lotowheel/lotowheel-modal-pozos.js';
import './js/modules/games/lotowheel/lotowheel-modal-virtual-draws.js';
import './js/modules/games/lotowheel/lotowheel-simulator.js';

// Event delegation (no importado por admin.js)
import './js/event-bindings.js';

// Componentes con side effects (DOMContentLoaded → injectAll)
import './js/components/modals.js';
